// Pure route → active-sidebar-item resolver, split out of side-bar-header so it
// can be unit-tested without the React/MUI nav tree.
//
// Audiences and the knowledge base have no nav entry of their own: audiences
// are reached from Launch Campaign and the knowledge base from the (legacy)
// Agents page, so their routes highlight the entry they live under.
import { SideBarItem } from './sidebar-items';

// Pathname → item for the routes whose highlight doesn't depend on the query.
const PATH_TO_SIDEBAR_ITEM: Record<string, SideBarItem> = {
    '/calendar': SideBarItem.Calendar,
    '/launch-campaign': SideBarItem.Campaigns,
    '/manage-campaigns': SideBarItem.Campaigns,
    '/manage-audiences': SideBarItem.Campaigns,
    '/manage-templates': SideBarItem.Campaigns,
    '/audience': SideBarItem.Campaigns,
    '/drips': SideBarItem.Drips,
    '/tasks': SideBarItem.Tasks,
    '/bot-list-view': SideBarItem.Agents,
    '/knowledge-base': SideBarItem.Agents,
    '/whatsapp-numbers': SideBarItem.WhatsAppNumbers,
    '/bt-team-inbox': SideBarItem.TeamInbox,
    '/agents': SideBarItem.MyBridge,
    '/connections': SideBarItem.WhatsAppConnections,
    '/refer': SideBarItem.Refer,
};

/**
 * Resolve which sidebar entry should be highlighted for the current route.
 * Every tab of /campaigns (audiences included) is Launch Campaign; everything
 * else maps by pathname alone.
 */
export function resolveActiveSidebarItem(pathname: string, _search: string): SideBarItem | undefined {
    if (pathname === '/campaigns') return SideBarItem.Campaigns;
    return PATH_TO_SIDEBAR_ITEM[pathname];
}
